// extracted by mini-css-extract-plugin
export default {"container":"footer_container__EsqWK","noSignedUser":"footer_noSignedUser__5pCap"};